<template lang="pug">
span
  v-menu(v-model="showMenu" rounded="lg" allow-overflow attach :close-on-content-click="false" offset-y max-height="420" min-width="450" max-width="600" nudge-bottom="8" z-index="11")
    template(v-slot:activator="{ on, attrs }")
      v-btn.px-2.button-text-normal.button-filter.text-none(v-if="selectedItems.length > 0" outlined rounded height="28" v-bind="attrs" v-on="on")
        v-icon.mr-1(@click.stop="clear" size=13) $yzi-x-circle
        .text-xs.font-semibold {{ $t('segment') }}
        .px-1.neutral400--text | 
        .text-xs.primary--text.font-medium {{ getSelectedMedications() }}
        v-icon.ml-1(size=16) $yzi-chevron-down
      v-btn.px-2.button-text-normal.border-dashed.button-filter(v-else outlined rounded height="28" v-bind="attrs" v-on="on")
        v-icon.mr-1(size=13) $yzi-plus-circle
        .text-xs.text-none.font-semibold {{ $t('segment') }}
    
    .white
      .menu-header.white
        .font-semibold.text-sm.pa-4 {{ $t('filter_by') }} {{ $t('segment').toLowerCase() }}
        v-text-field.text-sm.round-xl.mx-4.mb-3(v-model="searchText" @input="queryChanged" outlined :placeholder="$t('search')" dense hide-details)
        .d-flex.align-center.justify-end.px-4.py-3(v-if="count > pageSize")
          y-pagination(v-model="page" :pageSize="pageSize" :count="count" :loading="isLoading")
        v-divider

      v-skeleton-loader.pa-4(v-if="isLoading" type="text@3")
      div(v-else)
        template(v-if="segments.length > 0")
          div(v-for="segment in segments" :key="segment.value")
            .d-flex.text-sm.px-4.py-3.cursor-pointer.hover-bg(@click="clickItem(segment)")
              yc-checkbox(:input-value="isChecked(segment.value)" @change="clickItem(segment)")
              .ml-4 {{ segment.label }}
            v-divider.basic300
        template(v-else)
          .text-center.py-8.text-xs.neutral500--text No segment found
          
    .bottom-0.sticky.z-1.white
      .d-flex.align-center.px-4.py-3.border-t
        .text-sm.font-semibold.underline.normal-case.neutral700--text.cursor-pointer(v-if="!disabledButton" @click="clear") {{ $t('clear') }}
        v-spacer
        v-btn.button-sm(@click="apply" color="primary" depressed :disabled="disabledButton") {{ $t('apply') }}

</template>

<script>
import { debounce } from '@/utils'
import { mapGetters, mapActions } from 'vuex'

export default {
  props: ['filter'],
  components: {},
  data: () => ({
    showMenu: false,
    isLoading: true,
    searchText: '',
    segments: [],
    checkedItems: [],
    selectedItems: [],
    page: 1,
    pageSize: 20,
    count: 0,
    key: 'groups'
  }),
  computed: {
    ...mapGetters({
      company: 'getCompany',
    }),
    disabledButton () {
      return this.checkedItems.length === 0
    }
  },
  watch: {
    filter: {
      handler () {
        if (!this.filter.key) { this.clearData() }
      } 
    },
    page () {
      this.fetchSegments()
    },
    showMenu (value) {
      if (!value) {
        this.checkedItems = [...this.selectedItems]
      }
    }
  },
  mounted () {
    this.fetchSegments()
  },
  methods: {
    ...mapActions(['showMessage']),
    fetchSegments () {
      this.isLoading = true
      const params = {
        page: this.page,
        page_size: this.pageSize,
        search: this.searchText || ''
      }
      this.$axios.get(`/connect/${this.company.slug}/groups`, { params })
      .then(resp => {
        if (resp.data?.results) {
          this.segments = resp.data.results.map((item) => {
            return {
              label: item.title,
              value: `${item.id}`,
            }
          })
          this.count = resp.data.count
        } else {
          this.segments = []
        }
      })
      .catch(() => {
        this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
      })
      .finally(() => {
        this.isLoading = false
      })
    },
    clear () {
      this.clearData()
      this.$emit('update:filter', {})
    },
    clearData () {
      this.checkedItems = []
      this.selectedItems = []
    },
    apply () {
      this.showMenu = false
      this.selectedItems = [...this.checkedItems]
      this.$emit('update:filter', { key: this.key, value: this.checkedItems.map(i => i.value).join(',')})
    },
    clickItem (item) {
      if (this.checkedItems.map(i => i.value).includes(item.value)) {
        this.checkedItems = this.checkedItems.filter(x => x.value !== item.value)
      } else {
        this.checkedItems.push(item)
      }
    },
    getSelectedMedications () {
      const count = this.selectedItems.length
      if (count <= 2) {
        return this.selectedItems.map(x => x.label).join(', ')
      }
      return `${count} selected`
    },
    queryChanged: debounce(function () {
      this.page = 1
      this.fetchSegments()
    }, 750),
    isChecked (value) {
      return this.checkedItems.filter(item => item.value === value).length > 0
    }
  }
}
</script>

<style lang="scss" scoped>
.button-filter {
  min-width: 0 !important;
  color: #848484;
}
.menu-header {
  top: 0;
  position: sticky;
  z-index: 1;
}
</style>